import {SentryHelper} from '../helpers/sentry.helper';

import feedbackApi from '../api/feedback.api';

export const getFeedbackConfig = (restaurantCode, orderId, feedbackId) => () => {
  return feedbackApi.getFeedbackConfig(orderId, feedbackId)
    .catch(error => {
      SentryHelper.logException(new Error(error), {
          restaurantCode,
          error: error.response && error.response.data
        },
        { method: 'getFeedbackConfig' }
      );
      throw error;
    });
};

export const getMealFeedback = (restaurantCode, orderId, feedbackId) => () => {
  return feedbackApi.getMealFeedback(orderId, feedbackId)
    .catch(error => {
      SentryHelper.logException(new Error(error), {
          restaurantCode,
          error: error.response && error.response.data
        },
        { method: 'getMealFeedback' }
      );
      throw error;
    });
};

export const setFeedbackConfig = config => () => {
  return feedbackApi.setFeedbackConfig(config)
    .catch(error => {
      SentryHelper.logException(new Error(error), {
          restaurantCode: config.restaurantCode,
          error: error.response && error.response.data
        },
        { method: 'setFeedbackConfig' }
      );
      throw error;
    });
};

export const setMealFeedback = (feedbackId, feedback) => () => {
  return feedbackApi.setMealFeedback(feedbackId, feedback)
    .catch(error => {
      SentryHelper.logException(new Error(error), {
          restaurantCode: feedback.restaurantCode,
          error: error.response && error.response.data
        },
        { method: 'setMealFeedback' }
      );
      throw error;
    });
};



// WEBPACK FOOTER //
// ./actions/feedback.action.js